import React from 'react';
import styled from 'styled-components';
import {
  ShipmentFilters,
  BusinessFilter,
  RoutesCombinedFilter,
  TasksHandledByFilter,
  TransitStatusFilter,
} from 'components/ShipmentFilters';

import { useFilterCounters } from 'modules/tasks/filters/hooks';
import { useTasksFiltersContext } from './context';
import FTBFilter from '../../../components/ShipmentFilters/FTBFilter';

const selectProps = (width) => ({
  containerWidth: width,
});

const StyleOverwrites = styled.div`
  .spacer {
    margin: 0 40px;
  }

  > div:not(:last-child) {
    // Rows of filters
    margin-bottom: 8px;
  }

  label {
    border-radius: 0;
    width: 69.2px;
    border-color: #9b9b9b;
  }
`;

const Filters = () => {
  const { filters, handleChangeFilter } = useTasksFiltersContext();
  const { status: statusCounters } = useFilterCounters('transit_status') || {};
  const { owner: ownerCounters } = useFilterCounters('handled_by') || {};

  return (
    <StyleOverwrites>
      <ShipmentFilters
        wrapContent={false}
        rowMargin={false}
        status={filters}
        onChangeFilter={handleChangeFilter}
        rows={[
          [<RoutesCombinedFilter selectProps={selectProps(288)} />],
          [<BusinessFilter />, <div className="spacer" />, <FTBFilter />],
          [<TransitStatusFilter counters={statusCounters} />],
          [
            <TasksHandledByFilter
              filterUserGroups="ProdTech"
              minWidth={278}
              counters={ownerCounters}
            />,
          ],
        ]}
      />
    </StyleOverwrites>
  );
};

export default Filters;
